import { allValues, Rights } from '../rights';

export const RESIDENTIAL_AREA_MANAGEMENT_RIGHTS = Object.freeze([
  ...allValues(Rights.RESIDENTS),
  Rights.EMPLOYEES.READ.key,
  Rights.EMPLOYEES.WRITE.key,
  Rights.EMPLOYEES.GENERAL.READ.key,
  Rights.EMPLOYEES.CONTRACT.READ.key,
  ...allValues(Rights.EMPLOYEES.CHECKLIST),
  Rights.EMPLOYEES.FILES.READ.key,
  Rights.EMPLOYEES.FILES.WRITE.key,
  Rights.EMPLOYEES.WORK.READ.key,
  Rights.EMPLOYEES.CALENDAR.READ.key,
  Rights.EMPLOYEES.VACATION.READ.key,
  Rights.EMPLOYEES.MISC.READ.key,
  Rights.EMPLOYEES.TRAINING.READ.key,
  ...allValues(Rights.BASE_DATA),
  ...allValues(Rights.CARE),
  ...allValues(Rights.ADMINISTRATION_AND_INVOICING.PAYER),
  Rights.GENERAL.CASH_AMOUNT.READ.key,
  Rights.GENERAL.CASH_AMOUNT.WRITE.key,
  ...allValues(Rights.GENERAL.CALENDAR),
  ...allValues(Rights.GENERAL.CONTACTS),
  ...allValues(Rights.GENERAL.MESSAGES),
  Rights.ROSTER.PRINT.key,
  Rights.ROSTER.ACCESS.READ.key,
  Rights.ROSTER.ACCESS.WRITE.key,
  Rights.ROSTER.WEEK_PLAN.key,
  ...allValues(Rights.LISTS),
  ...allValues(Rights.ROSTER.VACATION_SCHEDULE),
]);
